import React from 'react';
import { graphql, Link } from 'gatsby';
import { useIntl } from 'react-intl';
import { GridContainer, GridItem } from '@entur/grid';
import {
  AdditionalZonesTicketIcon,
  ClockIcon,
  HorizontalDotsIcon,
  MapIcon,
  SearchIcon,
} from '@entur/icons';
import { NavigationCard } from '@entur/layout';
import { Heading2 } from '@entur/typography';
import ArticleHeader from '~/components/ArticleHeader';
import ContentWrapper from '~/components/ContentWrapper';
import { LanguageContext } from '~/components/LanguageProvider';
import PortableText from '~/components/PortableText';
import { toPlainText } from '~/lib/helpers';
import './index.scss';

export const query = graphql`
  query Reiseplanleggeren {
    ReiseplanleggerImage: file(
      relativePath: { eq: "Reisende/Reiseplanleggeren/Reiseplanleggeren.png" }
    ) {
      childImageSharp {
        gatsbyImageData(
          quality: 100
          placeholder: NONE
          layout: FULL_WIDTH
          formats: WEBP
        )
      }
    }
    allSanityReiseplanleggeren {
      edges {
        node {
          title {
            nb
            en
            nn
          }
          _rawExcerpt
          _rawContentPart1
          _rawContentPart2
        }
      }
    }
    allSanityOmreiseplanleggeren(sort: { pageOrder: ASC }) {
      edges {
        node {
          title {
            nb
            en
            nn
          }
          _rawExcerpt
        }
      }
    }
  }
`;

export function navCardIcon(title: string) {
  switch (title.toLowerCase()) {
    case 'hjem':
      return <SearchIcon />;
    case 'kart':
      return <MapIcon />;
    case 'billetter':
      return <AdditionalZonesTicketIcon />;
    case 'avganger':
      return <ClockIcon />;
    case 'mer':
      return <HorizontalDotsIcon />;
  }
}

const Reiseplanleggeren = ({ data }) => {
  const site = data.allSanityReiseplanleggeren.edges[0].node;
  const appMainPages = data.allSanityOmreiseplanleggeren.edges;
  const { formatMessage: f } = useIntl();
  const { language } = React.useContext(LanguageContext);

  return (
    <>
      <ArticleHeader
        title={site.title[language]}
        excerpt={toPlainText(site._rawExcerpt[language])}
        alt=""
      ></ArticleHeader>
      <ContentWrapper>
        <PortableText
          blocks={site._rawContentPart1[language]}
          disableScrollbarFix
        />
      </ContentWrapper>
      <ContentWrapper>
        <Heading2>
          {f({ id: 'reisende.omReiseplanleggeren.navcardSection' })}
        </Heading2>
        <GridContainer spacing="large">
          {appMainPages.map((appPage: any) => (
            <GridItem small={12} medium={6} key={appPage.node.title[language]}>
              <NavigationCard
                className="om-reiseplanelggeren__nav-card"
                title={appPage.node.title[language]}
                titleIcon={navCardIcon(appPage.node.title['nb'])}
                as={Link}
                to={
                  '/om-reiseplanleggeren/' +
                  appPage.node.title['nb'].toLowerCase()
                }
              >
                {toPlainText(appPage.node._rawExcerpt[language])}
              </NavigationCard>
            </GridItem>
          ))}
        </GridContainer>
      </ContentWrapper>
      <ContentWrapper style={{ marginTop: '2rem' }}>
        <PortableText
          blocks={site._rawContentPart2[language]}
          disableScrollbarFix
        />
      </ContentWrapper>
    </>
  );
};

export default Reiseplanleggeren;
